import * as React from "react";
const SvgIcBtnClose = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "m5 5 14 14m0-14L5 19", stroke: "#333", strokeWidth: 1.5, fill: "none", fillRule: "evenodd", strokeLinecap: "round" }));
export default SvgIcBtnClose;
